import React, {useState} from 'react'
import Stepper from 'react-stepper-horizontal'
import UploadFile from './Step1'
import RouteDetails from './Step2'
import RouteMultiHopDetails from './Step3'

/**
 * STEP 0
 * Component for uploading and validating Excel files for uploaded route master data.
 * 
 * @param {Array<Object>} routeMasterList - all route master data
 * @param {React.SetStateAction} setRouteMasterList - setter for route master data
 * @param {Array} added_list - array of new route(s)
 * @param {React.SetStateAction} setAdded_list - seetter for adding new routes
 * @param {string} company_id - company id
 * @returns {JSX.Element}
 */
const RouteUploadExcel = ({routeMasterList, setRouteMasterList, added_list, setAdded_list, company_id,superAdmins,emailTemplate,selectedOrg="company"}) => {
    const [step, setStep] = useState(0)
    const [uploadedData, setUploadedData] = useState([])

    return (
        <div>
            <Stepper 
                steps={[{title: 'Upload File'},
                {title:'Check Your Point-To-Point Route Details'},
                {title:'Check Your Multi-hop Route Details'}]} 
                activeStep={step}
                completeColor={'#54a63a'}
                completeTitleColor={'#54a63a'}
                activeColor={'#393186'}
                activeTitleColor={'#393186'}
                titleFontSize={14} 
                size={28}
                circleFontSize={14}
            />
            {step === 0 ? 
                <UploadFile
                    selectedOrg={selectedOrg}
                    step={step}
                    setStep={setStep}
                    uploadedData={uploadedData}
                    setUploadedData={setUploadedData}
                    company_id={company_id}
                />
            : null}
            {step === 1? 
                <RouteDetails
                    selectedOrg={selectedOrg}
                    superAdmins={superAdmins}
                    emailTemplates={emailTemplate}
                    step={step}
                    setStep={setStep}
                    uploadedData={uploadedData}
                    setUploadedData={setUploadedData}
                    routeMasterList={routeMasterList}
                    setRouteMasterList={setRouteMasterList}
                    setAdded_list={setAdded_list}
                    added_list={added_list}
                    company_id={company_id}
                />
            :null}
            {step === 2? 
                <RouteMultiHopDetails
                    selectedOrg={selectedOrg}
                    step={step}
                    setStep={setStep}
                    uploadedData={uploadedData}
                    setUploadedData={setUploadedData}
                    routeMasterList={routeMasterList}
                    setRouteMasterList={setRouteMasterList}
                    setAdded_list={setAdded_list}
                    added_list={added_list}
                />
            :null}
        </div>
    )
}

export default RouteUploadExcel
